// REDUCER
export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS'
export const AUTH_LOGIN_FAIL = 'AUTH_LOGIN_FAIL'
export const AUTH_LOGIN_UNAUTHORIZED = 'AUTH_LOGIN_UNAUTHORIZED'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const AUTH_START_LOGIN_REQUEST = 'AUTH_START_LOGIN_REQUEST'
export const AUTH_FINISH = 'AUTH_FINISH'
// MIDDLEWARE

export const AUTH_LOGOUT_MIDDLEWARE = 'AUTH_LOGOUT_MIDDLEWARE'
